import { QueryKeysEnum } from '@/enums';
import {
  QcAlertCountParam,
  QcAlertCountResponse,
  QcAlertEntity,
} from '@/types';
import APIService from './axios.service';
import { BaseService } from './base.service';

class QcAlertService extends BaseService<'qcAlert', QcAlertEntity> {
  constructor() {
    super(QueryKeysEnum.QC_ALERT);
  }

  getHistoricalCount = (
    payload: QcAlertCountParam,
  ): Promise<QcAlertCountResponse> => {
    return APIService.get(this.path + '/count', { params: payload });
  };
}

export const qcAlertService = new QcAlertService();
